var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import angular, { ITimeoutService } from 'angular';
import { Component } from 'decorators';
import view from './aiOutputsEdit.view.html';
import { translate } from 'angular';
import { AlertService } from 'modules/shared/AlertService';
import { UndoRedoService } from 'modules/application/misc/UndoRedoService';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { OutputAddNewState } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/outputs/components/outputs/outputs.dispatcher';
import { BuilderFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import { CardOutputContentIAction } from 'modules/application/detail/portal-submodule-builder/templates/builder/historyActions';
import { BuilderStore } from 'modules/application/detail/portal-submodule-builder/templates/builder/store/BuilderStore';
import { Condition, ConditionComparison, ValueSource } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Condition';
import { ActionType } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Action';
import { variableCondition, variableConditionHandoff, variableValueHandoff } from 'modules/application/detail/portal-submodule-builder/templates/builder/aiAgent/state/Outputs';
import { AgentSegmentService } from '../../../../services/AgentSegmentService';
import { BUILDER_AGENT_TARGETING_CANCELLED, BUILDER_AGENT_TARGETING_SAVED } from '../../../../events';
import { SchemaUtils } from '../../../../utils/SchemaUtils';
const builderStore = BuilderStore.getInstance();
let AiOutputsEdit = class AiOutputsEdit {
    static $inject = ['UndoRedoService', 'AlertService', 'BlipToastService', '$translate', '$timeout', 'AgentSegmentService'];
    //#endregion
    constructor(UndoRedoService, AlertService, BlipToastService, $translate, $timeout, AgentSegmentService) {
        this.filteredStatesList = [];
        this.isSchemaEditorEnabled = false;
        this.hasChanges = false;
        this.outputNameAlert = undefined;
        this.outputStateAlert = undefined;
        this.outputDescriptionAlert = undefined;
        this.outputParametersAlert = undefined;
        this.outputName = '';
        this.outputDescription = '';
        this.outputParameters = '';
        this.outputParametersToSave = '';
        this.oldOutputName = '';
        this.editorLoading = true;
        this.close = async () => {
            if (!this.hasChanges) {
                this.onClose?.();
            }
            else {
                await this.AlertService.show({
                    title: await this.$translate('aiOutputs.edit.alertLost.title'),
                    body: await this.$translate('aiOutputs.edit.alertLost.body'),
                    variant: 'warning',
                    icon: 'warning',
                    buttons: {
                        cancel: await this.$translate('aiOutputs.edit.alertLost.cancel'),
                        confirm: await this.$translate('aiOutputs.edit.alertLost.confirm'),
                    },
                    callback: {
                        cancelButtonAction: () => { },
                        confirmButtonAction: async () => {
                            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_TARGETING_CANCELLED);
                            this.onClose?.();
                        },
                    },
                });
            }
        };
        this.filteredStates = () => {
            if (!this.states || this.state.id === undefined) {
                this.filteredStatesList = [];
                return;
            }
            this.filteredStatesList = Object.keys(this.states)
                .filter(key => key !== this.state.id.toString())
                .map(key => this.states[key]);
        };
        this.onChangeValueOutputName = async (event) => {
            this.hasChanges = true;
            this.outputName = event.detail.value ?? '';
            this.outputNameAlert = await this.valueOutputNameValidate();
        };
        this.onChangeValueOutputDescription = async (event) => {
            this.hasChanges = true;
            this.outputDescription = event.detail.value ?? '';
            this.outputDescriptionAlert = await this.valueOutputDescriptionValidate();
        };
        this.changeOutputState = async ($data) => {
            this.hasChanges = true;
            this.selectecState = { typeOfStateId: $data.newTypeOfStateId, target: $data.newTarget };
            $data.output = this.output;
            this.outputStateAlert = await this.valueOutputStateValidate();
        };
        this.onOutputParametersChange = async ({ code }) => {
            this.outputParametersToSave = code;
            this.valueOutputParametersValidate();
        };
        this.onStructuredOutputChange = ($schema) => {
            const toStructuredOutput = SchemaUtils.jsonSchemaToStructuredOutput($schema);
            this.outputParametersToSave = JSON.stringify(toStructuredOutput, null, '\t');
            this.valueOutputParametersValidate();
        };
        this.onTabChange = () => {
            this.$timeout(() => {
                try {
                    this.outputParameters = this.outputParametersToSave;
                    this.outputParametersSchema = this.convertStructuredOutputToJsonSchema(JSON.parse(this.outputParameters));
                }
                catch (error) {
                    console.error('Error parsing output parameters:', error);
                }
                this.editor?.layout();
            }, 200);
        };
        this.valueOutputNameValidate = async () => {
            if (!this.outputName || this.outputName.trim().length < 3) {
                return this.$translate('aiOutputs.edit.definitionsTab.validateValueLength');
            }
            const IDENTIFIER_REGEXP = /^[a-z0-9_]*$/;
            if (!IDENTIFIER_REGEXP.test(this.outputName)) {
                return this.$translate('aiOutputs.edit.definitionsTab.validateValueChars');
            }
            let alredyInUse = false;
            this.state.$conditionOutputs.forEach((output, index) => {
                if (index !== this.index) {
                    if (output.conditions.some(cond => cond.variable === variableCondition &&
                        cond.source === ValueSource.Context &&
                        (cond.comparison === ConditionComparison.Equals || cond.comparison === ConditionComparison.Contains) &&
                        cond.values.some(value => value === this.outputName))) {
                        alredyInUse = true;
                    }
                }
            });
            if (alredyInUse) {
                return this.$translate('aiOutputs.edit.definitionsTab.validateValueAlreadyInUse');
            }
            return;
        };
        this.valueOutputStateValidate = async () => {
            if (this.selectecState.typeOfStateId === undefined) {
                return;
            }
            if (!this.selectecState.target || this.selectecState.target.trim() === '') {
                return this.$translate('aiOutputs.edit.definitionsTab.validateStateEmpty');
            }
            return;
        };
        this.valueOutputDescriptionValidate = async () => {
            if (!this.outputDescription || this.outputDescription.trim() === '') {
                return this.$translate('aiOutputs.edit.definitionsTab.validateDescriptionEmpty');
            }
            return;
        };
        this.valueOutputParametersValidate = () => {
            try {
                const schema = this.convertStructuredOutputToJsonSchema(JSON.parse(this.outputParametersToSave));
                const isValid = SchemaUtils.validateJson(JSON.stringify(schema));
                this.hasChanges = this.outputParametersToSave !== this.formatJsonUsingTabs(this.getHandoff(this.outputName)?.parameters);
                this.outputParametersAlert = isValid.valid ? undefined : this.$translate.instant('aiOutputs.edit.parametersTab.validateParametersInvalid');
            }
            catch (e) {
                this.outputParametersAlert = this.$translate.instant('aiOutputs.edit.parametersTab.validateParametersEmpty');
            }
        };
        this.didCreateEditor = (event) => {
            this.$timeout(() => {
                if (event && event.editor) {
                    this.editor = event.editor;
                    this.$timeout(() => {
                        this.editor.layout();
                        this.editorLoading = false;
                    }, 1000);
                    // disable minimap
                    this.editor.updateOptions({
                        minimap: {
                            enabled: false,
                        },
                    });
                }
            }, 2000);
        };
        //#endregion
        //#region Helper Methods
        this.formatJsonUsingTabs = (jsonObj) => {
            try {
                return JSON.stringify(jsonObj ?? {}, null, "\t");
            }
            catch (error) {
                console.error('Error formatting JSON:', error);
                return '{}';
            }
        };
        this.convertStructuredOutputToJsonSchema = (data) => {
            const structuredOutput = this.isStructuredDictionary(data) ? data : {};
            const jsonSchema = SchemaUtils.structuredOutputToJsonSchema(structuredOutput);
            return jsonSchema;
        };
        this.UndoRedoService = UndoRedoService;
        this.AlertService = AlertService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.AgentSegmentService = AgentSegmentService;
    }
    //#endregion
    //#region Lifecycle Hooks
    //#endregion
    $onInit() {
        this.output = this.state.$conditionOutputs[this.index];
        this.outputName = angular.copy(this.getCurrentValueConditionName());
        this.oldOutputName = angular.copy(this.outputName);
        this.selectecState = {
            typeOfStateId: angular.copy(this.output.typeOfStateId),
            target: angular.copy(this.output.stateId)
        };
        this.oldSelectecState = angular.copy(this.selectecState);
        this.forwardSettings = this.state.$enteringCustomActions.find(action => action.type === ActionType.ForwardToAgent)?.settings;
        const handoff = this.getHandoff(this.outputName);
        this.outputDescription = handoff?.description ?? '';
        this.outputParameters = this.formatJsonUsingTabs(handoff?.parameters);
        this.outputParametersSchema = this.convertStructuredOutputToJsonSchema(handoff?.parameters);
        this.outputParametersToSave = this.outputParameters;
        this.checkFeatures();
        this.checkAllValidates();
        this.filteredStates();
    }
    //#endregion
    //#region Methods
    async checkFeatures() {
        this.isBuilderUndoRedoOutputsEnabled = await BuilderFeatures.builderUndoRedoOutputsEnabled();
        this.isSchemaEditorEnabled = await BuilderFeatures.schemaEditorEnabled();
    }
    async checkAllValidates() {
        this.outputNameAlert = await this.valueOutputNameValidate();
        this.outputDescriptionAlert = await this.valueOutputDescriptionValidate();
        this.outputStateAlert = await this.valueOutputStateValidate();
        this.valueOutputParametersValidate();
    }
    getCurrentValueConditionName() {
        return this.getCurrentValueCondition()?.values[0] ?? '';
    }
    getCurrentValueCondition() {
        return this.output.conditions.find(cond => cond.variable === variableCondition &&
            cond.source === ValueSource.Context &&
            cond.comparison === ConditionComparison.Equals);
    }
    getHandoff(outputValue) {
        return this.forwardSettings?.handoffs?.find(handoff => handoff.name === outputValue);
    }
    saveOuputHandoff(name, description, parameters) {
        if (this.forwardSettings) {
            let parametersJson = undefined;
            try {
                parametersJson = JSON.parse(parameters);
            }
            catch (error) {
                console.log('error', error);
            }
            const handoffList = this.forwardSettings?.handoffs?.filter(handoff => handoff.name !== this.oldOutputName) ?? [];
            this.forwardSettings.handoffs = [...handoffList, { name, description, parameters: parametersJson }];
        }
    }
    getNewOutputConditions(outputValue) {
        return [
            new Condition({
                source: ValueSource.Context,
                variable: variableConditionHandoff,
                comparison: ConditionComparison.Equals,
                values: [variableValueHandoff]
            }),
            new Condition({
                source: ValueSource.Context,
                variable: variableCondition,
                comparison: ConditionComparison.Equals,
                values: [outputValue]
            }),
        ];
    }
    async save() {
        setTimeout(async () => {
            try {
                this.output.conditions = this.getNewOutputConditions(this.outputName);
                if (this.selectecState.typeOfStateId != undefined) {
                    this.output.stateId = this.selectecState.target;
                    this.output.typeOfStateId = this.selectecState.typeOfStateId;
                    if (this.isBuilderUndoRedoOutputsEnabled) {
                        this.UndoRedoService.add(this.changeOutputUndoRedoAction(this.selectecState.target, this.oldSelectecState?.target, this.selectecState.typeOfStateId, this.oldSelectecState?.typeOfStateId, this.index));
                    }
                }
                this.saveOuputHandoff(this.outputName, this.outputDescription, this.outputParametersToSave);
                this.hasChanges = false;
                this.onSave();
                this.close();
                this.BlipToastService.show('success', { msg: await this.$translate('aiOutputs.edit.toast.saveSuccess') });
                this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_TARGETING_SAVED, {
                    targetingName: this.outputName,
                    targettingDescription: this.outputDescription,
                    targettingBlock: this.selectecState.target,
                    targettingBlockName: this.filteredStatesList.find(s => s.id === this.selectecState.target)?.$title || '',
                });
            }
            catch (error) {
                console.error('Error saving output:', error);
                this.BlipToastService.show('danger', { msg: await this.$translate('aiOutputs.edit.toast.saveError') });
            }
        });
    }
    async $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
    }
    formIsNotValid() {
        return this.outputNameAlert != undefined ||
            this.outputDescriptionAlert != undefined ||
            this.outputStateAlert != undefined ||
            this.outputParametersAlert != undefined;
    }
    async addNewState($data) {
        const action = new OutputAddNewState({
            output: this.output,
            state: this.state,
            newTarget: $data.label,
            oldTarget: $data.oldTarget,
        });
        await this.$dispatch(action);
        await this.changeOutputState($data);
    }
    changeOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId, index) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                index: index,
                oldOutput: angular.copy(oldTarget),
                newOutput: angular.copy(newTarget),
                newTypeOfStateId,
                oldTypeOfStateId
            },
            execute: (data) => {
                const newTarget = data.newOutput;
                const currentState = builderStore.getState(data.state.id);
                currentState.$conditionOutputs[data.index].typeOfStateId = data.newTypeOfStateId;
                currentState.$conditionOutputs[data.index].stateId = newTarget;
                builderStore.setState({
                    ...currentState
                });
            },
            undo: (data) => {
                const newTarget = data.oldOutput || undefined;
                this.state.$conditionOutputs[data.index].typeOfStateId = data.oldTypeOfStateId;
                this.state.$conditionOutputs[data.index].stateId = newTarget;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState
                });
            },
        });
    }
    isStructuredDictionary(obj) {
        return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
    }
};
AiOutputsEdit.$inject = ['UndoRedoService', 'AlertService', 'BlipToastService', '$translate', '$timeout', 'AgentSegmentService'];
AiOutputsEdit = __decorate([
    Component({
        template: view,
        controllerAs: '$ctrl',
        bindings: {
            onClose: '&',
            onAction: '&?',
            onSave: '&',
            index: '<',
            state: '=?',
            states: '=?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof UndoRedoService !== "undefined" && UndoRedoService) === "function" ? _a : Object, typeof (_b = typeof AlertService !== "undefined" && AlertService) === "function" ? _b : Object, typeof (_c = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _c : Object, typeof (_d = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _d : Object, typeof (_e = typeof ITimeoutService !== "undefined" && ITimeoutService) === "function" ? _e : Object, typeof (_f = typeof AgentSegmentService !== "undefined" && AgentSegmentService) === "function" ? _f : Object])
], AiOutputsEdit);
export { AiOutputsEdit };
